import React from 'react';
export function Nav() {
  return <header className="sticky top-0 z-50 bg-white border-b border-border" data-id="element-225">
      <nav className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-226">
        <div className="flex items-center gap-2" data-id="element-227">
          <div className="w-2 h-2 rounded-full bg-cocoa" data-id="element-228"></div>
          <span className="font-mono text-[13px] text-text-primary" data-id="element-229">
            El Azúcar Silencioso
          </span>
        </div>

        <div className="hidden md:block" data-id="element-230">
          <span className="font-mono text-[11px] text-text-muted uppercase tracking-[0.15em]" data-id="element-231">
            Ebook · 3 Bonus · PDF · Descarga Inmediata
          </span>
        </div>

        <a href="#comprar" className="premium-btn-cocoa !py-2.5 !px-6 !text-[14px]" data-id="element-232">
          Descargar — $17.95
        </a>
      </nav>
    </header>;
}